import axios from 'axios';
import { BASE_URL } from "src/config/config";
import { toast } from 'react-toastify'

export const getAllBatches = async (currentPage, limit) => {
  try {
    let response = await axios.get(`${BASE_URL}apiBatch/getBatch`, {
      params: {
        page: currentPage,
        limit: limit
      }
    })
    if (response.status == '200') {
      console.log(response, "------------------")
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching records:', error);
    toast.error("Error fetching records", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  }
}

export const saveBatch = async (batchName) => {
  try {
    const response = await axios.post(`${BASE_URL}apiBatch/createBatch`, { batchName });

    if (response.status == "200") {
      console.log(response.data, "============================================")
      toast.success('Batch Added.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    // throw new Error(error.response.data.message || 'Failed to create batch'); // Throw an error if request fails
  }
};

export const deleteBatch = async (batchName) => {
  console.log(batchName, "batchName, -------------------------")
  try {
    const response = await axios.delete(`${BASE_URL}apiBatch/deleteBatch/${Number(batchName)}`);

    if (response.status === 200) {
      toast.success('Batch Deleted.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    throw error;
  }
}

export const updateBatchNameFunction = async (batchId, batchName) => {
  try {
    const response = await axios.patch(`${BASE_URL}apiBatch/updateBatchName`, { batchId, batchName });

    if (response.status === 200) {
      // console.log('Batch name updated successfully.');
      toast.success('Batch name updated successfully.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });

  }
}







